<div class="file-attachment-container">
    <div class="document-container">
        <div class="icon" (click)="onDeleteClick()">
            <i-lucide name="trash-2" size="20" strokeWidth="2" class="warning"></i-lucide>
        </div>
        <span class="link" [ngClass]="{ disabled: !downloadAvailable || downloading }" (click)="onDownloadClick()">{{
            fileName }}</span>
        <i-lucide *ngIf="downloading" name="loader" size="20" strokeWidth="2" class="spinner"></i-lucide>
    </div>
</div>